module.exports = __webpack_public_path__ + "415a64edbe1eabb3cf1ee2ba38ffe337.pdf";